import { render, staticRenderFns } from "./lyse.vue?vue&type=template&id=687f3fb0&scoped=true&"
var script = {}
import style0 from "./lyse.vue?vue&type=style&index=0&id=687f3fb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687f3fb0",
  null
  
)

export default component.exports